const yup = require("yup");

// Schema for createcollegerules
const createCollegeRules = yup.object({
	code: yup
		.string()
		.min(2, "Minimum of 2 characters expected")
		.required("Code is required"),
	name: yup
		.string()
		.min(2, "Minimum of 2 characters expected")
		.required("Name is required"),
	status: yup.boolean().required("Status is required"),
	isacademic: yup.boolean().required("IsAcademic is required"),
});

// Schema for createdeanrule
const createDeanRule = yup.object({
	staff: yup.string().required("Staff is required"),
	college: yup.string().required("College is required"),
});

module.exports = {
	createCollegeRules,
	createDeanRule,
};
